import { useScrollRestoration } from "@hooks/index";
import { Container, ContainerProps } from "@mui/material";

/**
 * 
 * @returns a Container component that saves the scroll position in local storage and restores it on mount based on the current pathname
 */
const ScrollfulContainer = (props: ContainerProps) => {
  const { scrollfulRef } = useScrollRestoration();

  return (
    <Container
    {...props}
      sx={{
        ...props.sx,
        height: "100%",
        overflow: "auto",
      }}
      ref={scrollfulRef}
    />
  );
};

export default ScrollfulContainer;
